import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mobile-header" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "mobile-flag-container" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "mobile-lottery-details" }
const _hoisted_7 = { class: "mobile-lottery-name" }
const _hoisted_8 = { class: "mobile-countdown-section" }
const _hoisted_9 = { class: "mobile-countdown" }
const _hoisted_10 = { class: "mobile-time-block" }
const _hoisted_11 = { class: "mobile-time" }
const _hoisted_12 = { class: "mobile-label" }
const _hoisted_13 = { class: "mobile-time-block" }
const _hoisted_14 = { class: "mobile-time" }
const _hoisted_15 = { class: "mobile-label" }
const _hoisted_16 = { class: "mobile-time-block" }
const _hoisted_17 = { class: "mobile-time" }
const _hoisted_18 = { class: "mobile-label" }

import { computed } from 'vue';
import { getGameLogoUrl } from '../../utils/resultParser';
import { useIntegrationMode } from '@/composables/useIntegrationMode';
import CountryAvatar from '@/components/base/CountryAvatar.vue';

interface Countdown {
  hours: string;
  minutes: string;
  seconds: string;
}

interface Props {
  gameName?: string;
  gameFormat?: string;
  countryFlag?: string;
  countryName?: string;
  countdown: Countdown;
  lottery?: any;
  showWatchLive?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileHeader',
  props: {
    gameName: { default: '' },
    gameFormat: { default: '' },
    countryFlag: { default: '' },
    countryName: { default: '' },
    countdown: {},
    lottery: { default: null },
    showWatchLive: { type: Boolean }
  },
  emits: ['go-back', 'watch-live'],
  setup(__props: any) {

const { isLite } = useIntegrationMode();

const props = __props;



const displayGameName = computed(() => props.lottery?.name || props.gameName || '');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "back-nav",
        "aria-label": _ctx.$t('common.back'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('go-back')))
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("span", {
          class: "back-button",
          "aria-hidden": "true"
        }, [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2.5",
              d: "M15 19l-7-7 7-7"
            })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          (_unref(isLite))
            ? (_openBlock(), _createBlock(CountryAvatar, {
                key: 0,
                country: _ctx.lottery?.country,
                "fallback-label": _ctx.lottery?.game_name,
                size: "sm"
              }, null, 8, ["country", "fallback-label"]))
            : (_ctx.lottery?.game_logo)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _unref(getGameLogoUrl)(_ctx.lottery.game_logo, _ctx.lottery.game_slug),
                  alt: _ctx.lottery.country + ' flag',
                  class: "mobile-flag"
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true)
        ])
      ], 8, _hoisted_3),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass(["mobile-lottery-title-row", { 'has-watch-live': _ctx.showWatchLive }])
        }, [
          _createElementVNode("h1", _hoisted_7, _toDisplayString(displayGameName.value), 1),
          (_ctx.showWatchLive)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "watch-live-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('watch-live')))
              }, [
                _cache[3] || (_cache[3] = _createElementVNode("span", {
                  class: "watch-live-icon",
                  "aria-hidden": "true"
                }, "▶", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('detail.watchLive')), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.countdown.hours), 1),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('time.hours')), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.countdown.minutes), 1),
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('time.mins')), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.countdown.seconds), 1),
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('time.secs')), 1)
        ])
      ])
    ])
  ]))
}
}

})